module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded1",
    attrs: {
      "id": "d7e215"
    }
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LSO IN THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KASHIC")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OIR")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERIES")]), _vm._v(":")])]), _vm._v(" "), _c('p', {
    staticClass: "ded",
    attrs: {
      "id": "d7e425"
    }
  }, [_c('b', [_c('i', [_vm._v("D.C. Noir")])]), _vm._v(", edited by George Pelecanos")]), _vm._v(" "), _c('p', {
    staticClass: "ded",
    attrs: {
      "id": "d7e495"
    }
  }, [_c('b', [_c('i', [_vm._v("Brooklyn Noir")])]), _vm._v(", edited by Tim McLoughlin")]), _vm._v(" "), _c('p', {
    staticClass: "ded",
    attrs: {
      "id": "d7e565"
    }
  }, [_c('b', [_c('i', [_vm._v("Brooklyn Noir 2: The Classics,")])]), _vm._v("edited by Tim McLoughlin")]), _vm._v(" "), _c('p', {
    staticClass: "ded",
    attrs: {
      "id": "d7e635"
    }
  }, [_c('b', [_c('i', [_vm._v("Chicago Noir,")])]), _vm._v("edited by Neal Pollack")]), _vm._v(" "), _c('p', {
    staticClass: "ded",
    attrs: {
      "id": "d7e715"
    }
  }, [_c('b', [_c('i', [_vm._v("San Francisco Noir")])]), _vm._v(", edited by Peter Maravelis"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded1",
    attrs: {
      "id": "d7e785"
    }
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORTHCOMING:")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded",
    attrs: {
      "id": "d7e875"
    }
  }, [_c('b', [_c('i', [_vm._v("Manhattan Noir")])]), _vm._v(", edited by Lawrence Block")]), _vm._v(" "), _c('p', {
    staticClass: "ded",
    attrs: {
      "id": "d7e945"
    }
  }, [_c('b', [_c('i', [_vm._v("Baltimore Noir,")])]), _vm._v("edited by Laura Lippman")]), _vm._v(" "), _c('p', {
    staticClass: "ded",
    attrs: {
      "id": "d7e1015"
    }
  }, [_c('b', [_c('i', [_vm._v("Twin Cities Noir")])]), _vm._v(", edited by Julie Schaper & Steven Horwitz")]), _vm._v(" "), _c('p', {
    staticClass: "ded",
    attrs: {
      "id": "d7e1085"
    }
  }, [_c('b', [_c('i', [_vm._v("Los Angeles Noir,")])]), _vm._v("edited by Denise Hamilton")]), _vm._v(" "), _c('p', {
    staticClass: "ded",
    attrs: {
      "id": "d7e1165"
    }
  }, [_c('b', [_c('i', [_vm._v("London Noir,")])]), _vm._v("edited by Cathi Unsworth")]), _vm._v(" "), _c('p', {
    staticClass: "ded",
    attrs: {
      "id": "d7e1235"
    }
  }, [_c('b', [_c('i', [_vm._v("Havana Noir")])]), _vm._v(", edited by Achy Obejas")]), _vm._v(" "), _c('p', {
    staticClass: "ded",
    attrs: {
      "id": "d7e1305"
    }
  }, [_c('b', [_c('i', [_vm._v("Wall Street Noir")])]), _vm._v(", edited by Peter Spiegelman")]), _vm._v(" "), _c('p', {
    staticClass: "ded",
    attrs: {
      "id": "d7e1375"
    }
  }, [_c('b', [_c('i', [_vm._v("Miami Noir")])]), _vm._v(", edited by Les Standiford")]), _vm._v(" "), _c('p', {
    staticClass: "ded",
    attrs: {
      "id": "d7e1445"
    }
  }, [_c('b', [_c('i', [_vm._v("Bronx Noir")])]), _vm._v(", edited by S.J. Rozan")]), _vm._v(" "), _c('p', {
    staticClass: "ded",
    attrs: {
      "id": "d7e1515"
    }
  }, [_c('b', [_c('i', [_vm._v("Lone Star Noir")])]), _vm._v(", edited by Edward Nawotka")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cea0c7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Brue_ISBN9781936070282_epub_ded3_r1.vue
// module id = 66
// module chunks = 0